// extracted by mini-css-extract-plugin
export default {"summaryCard":"RatingSummaryCard_summaryCard__xv3DF","categoryName":"RatingSummaryCard_categoryName__WxcfK","ratingValue":"RatingSummaryCard_ratingValue__hHVkq"};